import config from '../../capacitor.config';

const auth0Callback = (domain: string) =>
    `${config.appId}://${domain}/capacitor/${config.appId}/callback`;

export const devAuth0 = {
    auth0Domain: 'lido.jp.auth0.com',
    auth0ClientId: 'AOIueJ3HAJXkz1kORj0xtYw0mjY4MyvF',
    auth0Audience: 'lido-delivery-api',
    auth0CallbackUrl: auth0Callback('lido.jp.auth0.com'),
};

export const prodAuth0 = {
    auth0Domain: 'lido-prod.jp.auth0.com',
    auth0ClientId: 'USm8jWU7W5x7bFD4IAqoLFBDuPVwn75S',
    auth0Audience: 'https://lidodelivery.com',
    auth0CallbackUrl: auth0Callback('lido-prod.jp.auth0.com'),
};

export const baseEnvironment = {
    placeMarkerOnMapOnLoad: true,
    pixelId: '1526933941353500',
};
